import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { SupportFeedbackCollection } from './support-feedback.types';

const API_ENDPOINT = 'support/feedback.php';

export function supportFeedbackBackend(): Backend<SupportFeedbackCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: undefined,
    push: (_, feedback) => ({
      endpoint: API_ENDPOINT,
      isGaf: true,
      asFormData: true,
      payload: {
        support_ticket_id: feedback.supportTicketId,
        date_resolved: feedback.dateResolved,
        rating: feedback.rating,
        responsiveness: feedback.responsiveness,
        knowledge: feedback.knowledge,
        friendliness: feedback.friendliness,
        clarity: feedback.clarity,
        feedback: feedback.feedback,
      },
    }),
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
